<template>
  <v-card class="report-row" flat>
    <v-row>
      <v-col class="report-row__title">
        {{item.user}}
      </v-col>
      <v-col cols="auto" md="3" class="report-row__total" :inner-html.prop="item.total | price(2)">
      </v-col>
    </v-row>
    <div class="row">
      <div class="col-9 offset-1" v-for="paymentMethod of item.paymentMethods" :key="paymentMethod.name">
        {{paymentMethod.name}} <span class="float-right" :inner-html.prop="paymentMethod.sum | price(2)"></span>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  created () {
    this.localType = this.type
  }
}
</script>

<style lang="scss" scoped>
.report-row {
  padding: 15px;
  margin: 5px;
  font-size: 20px;
  border: 2px solid lightgrey;

  &__title {
    font-size: 23px;
  }
  &__details {
    font-size: 20px;
    color: grey;
  }
  &__total {
    padding-right: 20px;
    font-size: 30px;
    font-weight: bold;
  }
  .article-quantity {
    font-size: 20px;
    color: grey;
  }
}
</style>
